/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DepartmentNeed from './department-need';
import DepartmentNeedDetail from './department-need-detail';
import DepartmentNeedUpdate from './department-need-update';
import DepartmentNeedDeleteDialog from './department-need-delete-dialog';

const DepartmentNeedRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DepartmentNeed />} />
    <Route path="new" element={<DepartmentNeedUpdate />} />
    <Route path=":id">
      <Route index element={<DepartmentNeedDetail />} />
      <Route path="edit" element={<DepartmentNeedUpdate />} />
      <Route path="delete" element={<DepartmentNeedDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DepartmentNeedRoutes;
